export default "__VITE_ASSET__nfLzsews__"